import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { GApageView } from "../..";
import { useStorage } from "../../hook/useStorage";
import EditProfileModal from "./EditProfileModal";
import Locker from "./Locker";
import ProfileInfo from "./ProfileInfo";
import Score from "./Score";
import ProgressBar from "../components/ProgressBar";
import BlueHero from "../../../assets/images/sprites/blueHero.jpg";
// import { GApageView } from 'app';
// import { ProfileInfo, EditProfileModal } from '../components/profile';
// import { LoaderModal } from '../../genericComponents';

export default function UserData({ owner, userSearchProfile, paramUsermane }) {
  const [loading, setLoading] = useState(true);

  const [
    isShowModalEditProfileState,
    setIsShowModalEditProfileState,
  ] = useState(false);
  const image = useStorage(`avatars/${userSearchProfile.avatar}`);
  useEffect(() => {
    setLoading(true);
    GApageView("Home");
  }, []);

  useEffect(() => {
    // dispatch(
    //   programActions.getProgramReviewAction({ email: userSearchProfile.email }),
    // );
    // dispatch(userActions.getEducationsAction({ email: userSearchProfile.email }));
    setLoading(false);
  }, [userSearchProfile.email]);

  return (
    <>
      <BackgroundGrey>
        <EditProfileModal
          isShow={isShowModalEditProfileState}
          onHide={() => {
            setIsShowModalEditProfileState(false);
          }}
        />
        <Container>
          <ProfileInfo
            userSearchProfile={userSearchProfile}
            image={image}
            owner={owner}
            setIsShowModalEditProfileState={setIsShowModalEditProfileState}
          />
        </Container>
      </BackgroundGrey>
      {owner ? (
        <ProgressBar
          user={userSearchProfile}
          show={paramUsermane === userSearchProfile.username}
        />
      ) : null}

      <Container>
        {/* owner profile will use userProfile */}

        {/* locker */}
        <Locker email={userSearchProfile?.email} owner={owner} />
      </Container>
    </>
  );
}

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 8px 32px 60px 32px;
`;
const BackgroundGrey = styled.div`
  background: url("${BlueHero}");
  
`;
